export const ACTION_TYPE = {
  CANCEL: "cancel",
  SAVE: "save",
};
